import {Stay} from './stay.model';
import {Room} from './room/room.model';
import {Rate} from './rate/rate.model';
import {Guest} from '../guest/guest.model';
import {Payment} from './payment.model';
import {CommunicationPreferences} from '../communication/communication.preferences.model';
import {SegmentReferenceIds} from './segmentReferenceIds.model';
import {SpecialNightRate} from '../special-night-rate';

export class Reservation {
  confirmationNumber: string;
  cancellationNumber: string;
  hotelMnemonic: string;
  status: string;
  guest: Guest;
  additionalGuests: Array<Guest>;
  disclaimer: any;
  stay: Stay;
  room: Room;
  rate: Rate;
  corporateId: string;
  originalSellDate: string;
  communicationPreferences: CommunicationPreferences;
  specialNightRate: SpecialNightRate;
  segmentReferenceIds: SegmentReferenceIds;
  offerCode: string;
  payment?: Payment;
  constructor(confirmationNumber?: string) {
    this.confirmationNumber = confirmationNumber;
    this.stay = new Stay();
    this.room =  new Room();
    this.rate = new Rate();
    this.guest = new Guest();
    this.payment = new Payment();
    this.additionalGuests = new Array<Guest>();
    this.communicationPreferences = new CommunicationPreferences();
    this.specialNightRate = new SpecialNightRate();
    this.segmentReferenceIds = new SegmentReferenceIds();
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/reservation.model.ts